<template>
    <div class="page-content">

        <div id="soundlist" class="section bg-svg-dunes">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Sleep Jar for Bixby has been retired.</h1>
                        <p class="lead mb-5">Customers can continue using Sleep Jar on these popular platforms:</p>

                        <div class="row text-center">
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.quick_launch.alexa" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-amazon"></i>Alexa</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Android</a>
                            </div>
                            <div class="col-md-3 mb-5 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>iPhone</a>
                            </div>
                            <div class="col-md-3 mb-5 mr-auto">
                                <a :href="$root.app_link.firetv" target="_blank" class="btn btn-lg btn-light"><i class="fas mr-2 fa-tv"></i>Fire TV</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';
export default {
    data () {
        return {
            "sounds": require('../../assets/media.js'),
            "emit_config": {
                "pool": "sounds",
                "emitter": "sounds-stop"
            }
        };
    },
    name: 'sounds',
    metaInfo: {
        title: 'Samsung Bixby',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'The full list of sleep sounds on Samsung Bixby, available in Sleep Jar!'
            }
        ]
    },
    methods: {
    },
    computed: {
        "roughSoundCount": function(){
            return this.sounds.individual.length - this.sounds.individual.length%10;
        }
    },
    components: {
    },
    mounted(){
        EventBus.$on(this.emit_config.emitter, function(index){
            this.$refs.previews[index].stopAudio();
        }.bind(this));
    }
}
</script>
